var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgIntroduction5Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 255,
    viewBox: "0 0 343 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1604_10955)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 255,
    rx: 16,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.342 123.358L120.812 117.854L122.355 159.529H153.467L159.342 123.358Z",
    fill: "#F0AAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.002 198.291C198.049 210.151 189.16 238.463 184.504 259.392H114.914L107.838 202.777C107.838 202.777 101.909 165.88 99.5812 158.177C102.782 158.613 114.561 155.948 120.812 151.272C124.989 148.148 124.698 138.086 124.989 133.58L157.722 135.939V142.043C157.722 146.404 161.213 147.712 169.069 148.148C176.925 148.584 180.853 154.688 181.726 158.177C182.599 161.665 184.345 166.897 189.146 173.438C193.946 179.978 195.692 183.466 197.002 198.291Z",
    fill: "#AC725D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.055 224.27C124.143 228.905 122.204 238.214 126.691 245.223C131.841 253.266 143.022 254.675 150.006 248.16L217.218 185.469C218.826 183.969 219.739 181.87 219.739 179.671C219.739 173.33 212.663 169.555 207.396 173.087L131.055 224.27Z",
    fill: "#F0AAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.643 174.782C105.454 167.311 110.401 160.241 117.828 158.799C125.855 157.24 133.509 162.845 134.447 170.968L142.709 242.559C143.519 249.581 138.346 255.875 131.3 256.441C124.799 256.962 118.991 252.394 117.966 245.953L106.643 174.782Z",
    fill: "#AC725D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.162,
    y: 62.0234,
    width: 66.8376,
    height: 68.4103,
    rx: 27,
    fill: "#F0AAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.708 121.988C137.882 115.288 136.349 108.866 135.436 106.493C135.436 106.493 139.291 93.4777 151.086 84.8281C162.88 76.1786 177.974 76.0995 177.974 76.0995C168.079 49.1345 142.258 48.5941 124.64 58.1228C107.022 67.6515 105.715 82.6941 103.684 94.2897C101.652 105.885 97.7989 116.498 93.8808 135.067C89.9627 153.636 85.9317 172.849 107.208 176.577C128.483 180.305 128.711 152.457 128.889 143.857C129.067 135.256 135.241 130.362 136.708 121.988Z",
    fill: "#6C4130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.329 100.413L176.011 96.6234L175.638 107.96C175.811 107.866 176.507 107.521 177.909 106.895C179.661 106.112 182.421 105.202 182.869 103.113C183.248 101.341 182.539 100.555 182.329 100.413Z",
    fill: "#F0AAA2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.429,
    cy: 102.444,
    r: 6.60795,
    fill: "#F0AAA2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.11,
    cy: 96.2426,
    rx: 1.33168,
    ry: 3.55114,
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.427 113.922C173.724 114.053 169.609 113.922 166.778 112.35",
    stroke: "#E47C70",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.284,
    y: 125.889,
    width: 4.64257,
    height: 41.6899,
    rx: 2,
    transform: "rotate(25.0815 245.284 125.889)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 70.0256C271 88.2652 256.214 103.051 237.974 103.051C219.735 103.051 204.949 88.2652 204.949 70.0256C204.949 51.7861 219.735 37 237.974 37C256.214 37 271 51.7861 271 70.0256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.376 72L234.754 82.6534L252.545 63.2266",
    stroke: "#3A7EFC",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.221 111.707C238.451 113.04 236.526 113.04 235.757 111.707L228.706 99.4944C227.936 98.161 228.898 96.4944 230.438 96.4944L244.54 96.4944C246.079 96.4944 247.041 98.161 246.272 99.4944L239.221 111.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.102 183.025L208.094 193.731L191.915 183.742C208.628 173.557 217.96 164.104 220.493 162.62C223.658 160.764 229.056 162.404 230.217 162.719C231.495 163.065 231.168 162.603 231.495 162.282C233.02 160.486 235.954 154.618 238.637 151.808C241.991 148.295 244.392 148.434 245.305 148.672C246.036 148.863 246.139 149.215 246.099 149.367C243.165 154.696 238.741 167.233 238.225 168.464C237.71 169.694 237.005 170.339 236.717 170.508L219.102 183.025Z",
    fill: "#F0AAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.357 240.384C148.78 234.11 145.312 220.792 144.774 214.918L128.545 219.586L128.399 246.001L143.224 255.223L158.357 240.384Z",
    fill: "#AC725D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.146 152.058L229.568 154.788C230.148 155.903 230.172 157.225 229.631 158.359L224.733 168.624C224.166 169.813 223.023 170.622 221.713 170.762C218.382 171.119 216.258 167.299 218.318 164.657L228.146 152.058Z",
    fill: "#F0AAA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1604_10955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 255,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIntroduction5Mobile);
export default __webpack_public_path__ + "static/media/ImgIntroduction5Mobile.3edc4c09c66ed6349aded25d9da88941.svg";
export { ForwardRef as ReactComponent };